import { render } from "./uk11.vue?vue&type=template&id=8524d23e"
import script from "./uk11.vue?vue&type=script&lang=js"
export * from "./uk11.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__